import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { sharedConfig } from '../base-config';

const app = initializeApp(sharedConfig.FIREBASE);
export const firestore = getFirestore(app);
